/* projects/speaker-platform/src/app/pages/password-reset/password-reset.component.scss */
h1 {
  font-family: "roboto", sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 32px;
  margin: 60px 0;
}
h2 {
  font-family: "roboto", sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 22px;
}
.error-feedback {
  color: #952626;
  font-size: 14px;
}
.login {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  height: 100%;
}
.login__content {
  grid-area: 1/1/2/2;
  height: 100%;
  background-color: #fff;
  position: relative;
}
.login__loader {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 9;
  transform: translateY(-50%) translateX(-50%) scale(3);
}
.login__loader--is-loading {
  display: block;
}
.login__contentwrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  width: 70%;
}
.login__contentwrapper--is-loading {
  filter: blur(5px);
}
.login__logo {
  margin: 32px 0 0 32px;
}
.login__form {
  margin: 0 auto;
}
.login__footer {
  position: absolute;
  bottom: 15px;
  left: 15px;
  font-size: 12px;
}
.login__illustration {
  grid-area: 1/2/2/4;
  background-image: url("./media/login-background-6B3YCR6M.jpg");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}
/*# sourceMappingURL=password-reset.component-V766YV2G.css.map */
